import { CustomerUsersActionTypes, CustomerUsersActions } from '@appStore/customers/actions/customer-users.actions';
import { CustomerUser } from '../../../models/customer-user.model';

export interface State {
  loading: boolean;
  loaded: boolean;
  data: CustomerUser[];
  selected: CustomerUser;
  displayTabSelected: number;
  updated: boolean;
  primaryUpdated: boolean;
  removing: boolean;
  removed: boolean;
  created: boolean;
  bulkUpdating: boolean;
  bulkUpdated: boolean;
  bulkRemoving: boolean;
  bulkRemoved: boolean;
}

export const initialState: State = {
  loading: false,
  loaded: false,
  data: [],
  selected: null,
  displayTabSelected: 0,
  updated: false,
  primaryUpdated: false,
  removing: false,
  removed: false,
  created: false,
  bulkUpdating: false,
  bulkUpdated: false,
  bulkRemoving: false,
  bulkRemoved: false
};

export function reducer(state = initialState, action: CustomerUsersActions): State {
  switch (action.type) {
    case CustomerUsersActionTypes.CustomerUserDisplayTabChanged:
      return { ...state, displayTabSelected: action.payload };

    case CustomerUsersActionTypes.CustomerUsersLoadData:
      return { ...state, loading: true, loaded: false };
    case CustomerUsersActionTypes.CustomerUsersLoadSuccess:
      return { ...state, data: action.payload, loading: false, loaded: true };
    case CustomerUsersActionTypes.CustomerUsersLoadFail:
      return { ...state, data: [], loading: false, loaded: false };
    case CustomerUsersActionTypes.CustomerUsersSelect:
      if (state.selected && action.payload.customerId === state.selected.customerId) {
        return state;
      }
      return { ...state, selected: action.payload, displayTabSelected: 0 };

    case CustomerUsersActionTypes.CustomerUserRemove:
      return { ...state, removing: true, removed: false };
    case CustomerUsersActionTypes.CustomerUserRemoveSuccess:
      const removedItem = action.payload;
      return {
        ...state,
        removing: false,
        removed: true,
        data: state.data.filter(
          item =>
            item.userId !== removedItem.userId ||
            item.clientId !== removedItem.clientId ||
            item.customerId !== removedItem.customerId
        )
      };
    case CustomerUsersActionTypes.CustomerUserRemoveFail:
      return { ...state, removing: false, removed: false };

       // BulkRemove - Customers from User
    case CustomerUsersActionTypes.BulkRemoveCustomerUser:
      return { ...state, bulkRemoving: true, bulkRemoved: false };
    case CustomerUsersActionTypes.BulkRemoveCustomerUserSuccess:
      return { ...state, bulkRemoving: false, bulkRemoved: true };
    case CustomerUsersActionTypes.BulkRemoveCustomerUserFail:
      return { ...state, bulkRemoving: false, bulkRemoved: false };

    case CustomerUsersActionTypes.UpdateCustomerUser:
      return { ...state, updated: false };
    case CustomerUsersActionTypes.UpdateCustomerUserSuccess:
      const updatedItem = action.payload;
      return {
        ...state,
        selected: null,
        updated: true,
        data: state.data.map(item =>
          item.userId === updatedItem.userId &&
          item.customerId === updatedItem.customerId &&
          item.clientId === updatedItem.clientId
            ? updatedItem
            : item
        )
      };

    case CustomerUsersActionTypes.CreateCustomerUser:
      return { ...state, created: false };
    case CustomerUsersActionTypes.CreateCustomerUserSuccess:
      const addedItem = action.payload;
      return {
        ...state,
        selected: null,
        created: true,
        data: [...state.data, action.payload]
      };

    case CustomerUsersActionTypes.BulkUpdateCustomerUser:
        return { ...state, bulkUpdating: true, bulkUpdated: false };
    case CustomerUsersActionTypes.BulkUpdateCustomerUserSuccess:
        return { ...state, bulkUpdating: false, bulkUpdated: true };
    case CustomerUsersActionTypes.BulkUpdateCustomerUserSuccess:
        return { ...state, bulkUpdating: false, bulkUpdated: false };
  
    case CustomerUsersActionTypes.SetPrimaryCustomerUser:
      return { ...state, primaryUpdated: false };
    case CustomerUsersActionTypes.SetPrimaryCustomerUserSuccess:
      const setItem = action.payload;
      let oldSetItem = state.data.find(
        x => x.isPrimaryContactPerson && x.customerId === setItem.customerId && x.clientId === setItem.clientId
      );

      if (oldSetItem) {
        oldSetItem = { ...oldSetItem, isPrimaryContactPerson: false };
      }

      return {
        ...state,
        selected: null,
        primaryUpdated: true,
        data: [
          ...state.data.filter(
            item =>
              !(
                (item.userId === setItem.userId || item.userId === oldSetItem.userId) &&
                item.customerId === setItem.customerId &&
                item.clientId === setItem.clientId
              )
          ),
          setItem,
          oldSetItem
        ]
      };
  }
  return state;
}

export const getCustomerUsers = (state: State) => state.data;
export const getCustomerUsersLoading = (state: State) => state.loading;
export const getCustomerUsersLoaded = (state: State) => state.loaded;
export const getCustomerUsersSelected = (state: State) => state.selected;
export const getCustomerUsersSelectedTab = (state: State) => state.displayTabSelected;
export const getCustomerUserUpdated = (state: State) => state.updated;
export const getSetPrimaryCustomerUserUpdated = (state: State) => state.primaryUpdated;
export const getCustomerUserRemoved = (state: State) => state.removed;
export const getCustomerUserCreated = (state: State) => state.created;
export const getCustomerUserBulkUpdated = (state: State) => state.bulkUpdated;
export const getCustomerUserBulkRemoved = (state: State) => state.bulkRemoved;
